import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

interface IProps {
    close: () => void;
}
function WAP({ close }: IProps): JSX.Element {
    const { is_client } = IM.SDKServer.getState();
    const {
        base_config: { game },
        stage
    } = useSelector(
        ({ IMReducer, IndexReducer }) => ({
            stage: IMReducer.stage,
            queue: IMReducer.queue,
            base_config: IndexReducer.base_config
        }),
        shallowEqual
    );
    return (
        <div className="im-header">
            <div className="im-game-info">
                <i className="game-icon" />
                <span className="game-name">{game?.name}</span>
            </div>
            {/* 人工阶段且无客服在线用户提交留言 */}
            {stage === 2 && !is_client && (
                <div className="im-control">
                    <button className="end-chat" onClick={close}>
                        结束会话
                    </button>
                </div>
            )}
        </div>
    );
}

export default WAP;
